import PageBase from './PageBase';
import CourierPageBase from './CourierPageBase';
import ConfirmationModal from './ConfirmationModal';
import ModalBase from './ModalBase';
import AdminPageBase from './AdminPageBase';
import AdminContainer from './AdminContainer';
import Carousel from './Carousel';
import Footer from './Footer';
import Navigator from './Navigator';
import Info from './Info';
import TooltipBase from './TooltipBase';
import Balance from './Balance';
import StorageQuota from './StorageQuota';
import Progress from './Progress';

const Elements = {
  PageBase,
  CourierPageBase,
  ConfirmationModal,
  ModalBase,
  AdminPageBase,
  AdminContainer,
  Carousel,
  Footer,
  Navigator,
  Info,
  TooltipBase,
  Balance,
  StorageQuota,
  Progress,
};

export default Elements;
